module.exports = __webpack_public_path__ + "static/cream-bread-aeb7c736f4cad62773c990453cdc55c1.jpg";